<template>
  <div class="timeTip">
    <span>{{msgObj.sendTime | dateFormat('MM月dd日 hh:mm')}}</span>
  </div>
</template>

<script>
export default {
  name: 'time-tip',
  props: {
    msgObj: Object
  }
}
</script>

<style>
  .timeTip {
    width: 100%;
    text-align: center;
    font-size: 13px;
    margin: 10px 0 20px;
  }

  .timeTip span {
    color: #ffffff;
    border-radius: 6px;
    border: 1px solid #d1d1d1;
    background-color: #d1d1d1;
    padding: 5px;
  }
</style>




// WEBPACK FOOTER //
// src/components/templates/TimeTip.vue